import { render, staticRenderFns } from "./onlineWechatAlipay.vue?vue&type=template&id=4c12bfc8&scoped=true&"
import script from "./onlineWechatAlipay.vue?vue&type=script&lang=js&"
export * from "./onlineWechatAlipay.vue?vue&type=script&lang=js&"
import style0 from "./onlineWechatAlipay.vue?vue&type=style&index=0&id=4c12bfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12bfc8",
  null
  
)

export default component.exports